// src/pages/procurement/components/ProductThumb.jsx
import React, { useState } from 'react';
import { Package } from 'lucide-react';
import { getProcurementItemImage } from '../../../utils/imageUtils';
import styles from './ProcurementDetails.module.css';

const ProductThumb = ({ item, src: srcOverride, alt = '' }) => {
  const [failed, setFailed] = useState(false);
  const src = srcOverride !== undefined ? srcOverride : getProcurementItemImage(item);

  if (!src || failed) {
    return (
      <div className={styles.productThumbPlaceholder}>
        <Package size={18} />
      </div>
    );
  }

  return <img src={src} alt={alt} className={styles.productThumb} onError={() => setFailed(true)} />;
};

export default ProductThumb;
